import { createContext, useContext, useEffect, useState } from "react";
import { translations } from "@/lib/i18n";

const LanguageContext = createContext({
  locale: "fr",
  setLocale: () => {},
  t: (k) => k,
});

export const LanguageProvider = ({ children }) => {
  const [locale, setLocale] = useState(() => {
    if (typeof window === "undefined") return "fr";
    const stored = window.localStorage.getItem("iko_locale");
    if (stored === "fr" || stored === "en") return stored;
    return "fr";
  });

  useEffect(() => {
    if (typeof window !== "undefined") {
      window.localStorage.setItem("iko_locale", locale);
      document.documentElement.lang = locale;
    }
  }, [locale]);

  const t = (path) => {
    const parts = path.split(".");
    let node = translations[locale];
    for (const p of parts) {
      if (node && typeof node === "object" && p in node) node = node[p];
      else return path;
    }
    return node;
  };

  return (
    <LanguageContext.Provider value={{ locale, setLocale, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);
